export const getInitials = (nameString: string): string => {
  const fullName = nameString.split(" ");
  if (fullName.length >= 2) {
    // @ts-ignore
    const initials = fullName.shift().charAt(0) + fullName.pop().charAt(0);
    return initials.toUpperCase();
  }
  return nameString.charAt(0);
};
